module.exports = __webpack_public_path__ + "static/26c42ed9f394679fd55edd0b99aad9bfbdfa4dff30c9f44acdbf91477328d68d-241d48f9365bbb38194bf018f4fd9a0f.png";